// ROTATE MENU ARROWS
function rotateMenuArrow() {
  document.querySelector("body").classList.add("mouse");
  let titleArrowMenu = document.querySelectorAll(".menu_title_arrow");
  for (let el of titleArrowMenu) {
    if (!el.classList.contains("langs")) {
      let elArrow = el.querySelector(".nav_item_arrow");
      if (elArrow) {
        mouseoverElement(el, elArrow);
        mouseoutElement(el, elArrow);
        if (el.nextElementSibling !== null) {
          mouseoverElement(el.nextElementSibling, elArrow);
          mouseoutElement(el.nextElementSibling, elArrow);
        }
      }
    }
  }
}
function mouseoverElement(el, elArrow) {
  el &&
    el.addEventListener("mouseover", function () {
      elArrow.classList.add("rotate_arrow");
    });
}
function mouseoutElement(el, elArrow) {
  el &&
    el.addEventListener("mouseout", function () {
      elArrow.classList.remove("rotate_arrow");
    });
}

// END ROTATE MENU ARROWS
// FOR BURGER MENU
export function toggleHeaderMenu(menuEl, btnMenuEl) {
  btnMenuEl &&
    btnMenuEl.addEventListener("click", function () {
      closeAllSubmenu(menuEl);
      btnMenuEl.classList.toggle("active");
      menuEl.classList.toggle("active");
      document.querySelector("body").classList.toggle("lock");
    });
}

export function toggleMainMenu() {
  let headerBurger = document.querySelector(".header_burger");
  let headerMenu = document.querySelector(".header_menu");
  toggleHeaderMenu(headerMenu, headerBurger);
}

export function toggleSecondMenu() {
  let secondHeaderArrow = document.querySelector(".second_header_arrow");
  let secondHeaderMenu = document.querySelector(".second_header_menu");
  toggleHeaderMenu(secondHeaderMenu, secondHeaderArrow);
}
// END FOR BURGER MENU
// CHECK SCROLL UP/DOWN, SHOW/HIDE MAIN MENU AND SLOGAN
let scrollPos = window.pageYOffset;
let headerScroll = document.querySelector(".header");
let sloganScroll = document.querySelector(".menu_slogan_bg");
let secondHeaderScroll = document.querySelector(".second_header");
let bodyPage = document.querySelector(".container_body_page");
let searchBlockHeader = document.querySelector(".block_search_input");

export function scrollSecondHeaderListener() {
  window.addEventListener("scroll", showHideSecondHeader);
}

export function scrollMainHeaderListener() {
  window.addEventListener("scroll", showHideMainHeader);
}

// show/hide main header 
function showHideMainHeader() {
  if (!searchBlockHeader.classList.contains("active")) {
    if(window.pageYOffset < 120) {
      headerScroll.classList.remove("hide");
    } else {
      if (scrollPos > window.pageYOffset) {
        headerScroll.classList.remove("hide");
      } else {
        headerScroll.classList.add("hide");
      }
    }
    // saves the new position for iteration.
    scrollPos = window.pageYOffset;
  }
}
export function removeScrollMainMenu() {
  window.removeEventListener("scroll", showHideMainHeader);
}

// show/hide slogan and second header 
function showHideSecondHeader() {
  if (sloganScroll && !sloganScroll.classList.contains("active_search")) {
    if(window.pageYOffset < 120) {
      headerScroll.classList.remove("hide");
      sloganScroll.classList.remove("hide");
      secondHeaderScroll.classList.remove("hide");
      bodyPage.classList.remove("padding_top");
    } else {
      if (scrollPos > window.pageYOffset) {
        headerScroll.classList.remove("hide");
        sloganScroll.classList.remove("hide");
        secondHeaderScroll.classList.remove("hide");
        bodyPage.classList.remove("padding_top");
      } else {
        headerScroll.classList.add("hide");
        sloganScroll.classList.add("hide");
        secondHeaderScroll.classList.add("hide");
        bodyPage.classList.add("padding_top");
      }
    }
    // saves the new position for iteration.
    scrollPos = window.pageYOffset;
  }
}
export function removeScrollSecondMenu() {
  window.removeEventListener("scroll", showHideSecondHeader);
}
// CHECK SCROLL UP/DOWN, SHOW/HIDE MAIN MENU AND SLOGAN
// CHECK MOBILE DEVICE
export function checkMobDevice() {
  if (
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    )
  ) {
    return true;
  } else {
    return false;
  }
}
// END CHECK MODILE DEVICE

export function mobileToggleSubmenu() {
  document.querySelector("body").classList.add("touch");
  let arrow = document.querySelectorAll(".menu_title_arrow");
  for (let i = 0; i < arrow.length; i++) {
    if (!arrow[i].classList.contains("not_arrow")) {
      let thisLink = arrow[i].previousElementSibling;
      let subMenu = arrow[i].nextElementSibling;
      arrow[i].addEventListener("click", function () {
        // closeAllSubmenu(this);
        arrow[i]
          .querySelector(".nav_item_arrow")
          .classList.toggle("rotate_arrow");
        subMenu.classList.toggle("open");
      });
    }
  }
}

function closeAllSubmenu(currentEl) {
  let arrow = document.querySelectorAll(".menu_title_arrow");
  for (let i = 0; i < arrow.length; i++) {
    if (!arrow[i].classList.contains("not_arrow")) {
      if (!currentEl.isSameNode(arrow[i])) {
        let subMenu = arrow[i].nextElementSibling;
        arrow[i]
          .querySelector(".nav_item_arrow")
          .classList.remove("rotate_arrow");
        subMenu.classList.remove("open");
        subMenu.classList.remove("show_langs");
      }
    }
  }
}


export function desktopToggleLangs() {
  let arrow = document.querySelectorAll(".menu_title_arrow");
  for (let i = 0; i < arrow.length; i++) {
    if (arrow[i].classList.contains("langs")) {
      let thisLink = arrow[i].previousElementSibling;
      let subMenu = arrow[i].nextElementSibling;
      arrow[i].addEventListener("click", function () {
        arrow[i].querySelector(".nav_item_arrow").classList.toggle("rotate_arrow");

        if (subMenu.classList.contains("tablet")) {
          subMenu.classList.toggle("open");
        } else {
          subMenu.classList.toggle("show_langs");
        }
        
      });
    }
  }
}

window.addEventListener("click", function(event){
  if (
        !event.target.closest(".menu_title_arrow.langs") &&
        !event.target.closest(".sub_menu_list.sub_menu_list_lang")
      ) {
        closeAllSubmenuLang();
      }
});

function closeAllSubmenuLang() {
  let arrow = document.querySelectorAll(".menu_title_arrow.langs");
  for (let i = 0; i < arrow.length; i++) {
    if (!arrow[i].classList.contains("not_arrow")) {
      let subMenu = arrow[i].nextElementSibling;
        arrow[i]
          .querySelector(".nav_item_arrow")
          .classList.remove("rotate_arrow");
        subMenu.classList.remove("open");
        subMenu.classList.remove("show_langs");
    }
  }
}



// TOGGLE SEARCH BLOCK
export function listenerSearchBlock() {
  let desktopSearchIcon = document.querySelector("#desktop_search_icon");
  let mobileSearchIcon = document.querySelector("#mobile_search_icon");
  let blockSearchInput = document.querySelector(".block_search_input");
  toggleSearchBlock(desktopSearchIcon, blockSearchInput);
  toggleSearchBlock(mobileSearchIcon, blockSearchInput);
}
function toggleSearchBlock(searchIcon, searchBlock) {
  searchIcon &&
    searchIcon.addEventListener("click", function () {
      closeAllSubmenu(this);
      if (document.querySelectorAll(".second_header").length > 0) {
        searchBlock.classList.toggle("active");
        document
          .querySelector(".menu_slogan_bg")
          .classList.toggle("active_search");
        document
          .querySelector(".second_header")
          .classList.toggle("active_search");
      } else {
        searchBlock.classList.toggle("active");
      }
    });
}
// END TOGGLE SEARCH BLOCK

// SHOW/HIDE BASKET MENU BLOCK
export function toggleBasketBlock() {
  let basketIconEls = document.querySelectorAll("#basket_menu");
  let basketBlockMenu = document.querySelector(".block_basket_buy_menu");
  for (let el of basketIconEls) {
    el.addEventListener("click", function () {
      el.nextElementSibling.classList.toggle("show");
      if (el.nextElementSibling.classList.contains("show")) {
        lockScroll();
      } else {
        unlockScroll();
      }
    });
  }
}
function closeActiveBasket(btnElName, blockElName) {
  window.onclick = function (event) {
    if (
      !event.target.closest(btnElName) &&
      !event.target.closest(blockElName)
    ) {
      var dropdown = document.querySelector(blockElName);
      if (dropdown.classList.contains("show")) {
        dropdown.classList.remove("show");
        unlockScroll();
      }
    }
  };
}
export function checkDisplayForBasket() {
  if (window.matchMedia("(max-width: 992px)").matches) {
    closeActiveBasket(".mobile_basket_icon", ".mobile_basket_block");
  } else {
    closeActiveBasket("#basket_menu", ".block_basket_buy_menu");
  }
}

export function closeBasketKeyword() {
  document.addEventListener("keydown", function (e) {
    if (e.which === 27) {
      document.querySelector(".block_basket_buy_menu").classList.remove("show");
      unlockScroll();
    }
  });
}
// END SHOW/HIDE BASKET MENU BLOCK

// LANGS

// let langs = [
//   {
//       lang: 'Amharic',
//       link: 'am',
//       isActive: false
//   },
//   {
//       lang: 'Arabic',
//       link: 'ar',
//       isActive: true
//   },
//   {
//       lang: 'Basque',
//       link: 'eu',
//       isActive: false
//   },
//   {
//       lang: 'Bengali',
//       link: 'bn',
//       isActive: false
//   },
//   {
//       lang: 'Portuguese',
//       link: 'pt',
//       isActive: false
//   },
//   {
//       lang: 'Bulgarian',
//       link: 'bg',
//       isActive: false
//   },
//   {
//       lang: 'Catalan',
//       link: 'ca',
//       isActive: false
//   },
//   {
//       lang: 'Croatian',
//       link: 'hr',
//       isActive: false
//   },
//   {
//       lang: 'Czech',
//       link: 'cs',
//       isActive: false
//   },
//   {
//       lang: 'Danish',
//       link: 'da',
//       isActive: false
//   },
//   {
//       lang: 'Dutch',
//       link: 'nl',
//       isActive: false
//   },
//   {
//       lang: 'Estonian',
//       link: 'et',
//       isActive: false
//   },
//   {
//       lang: 'Filipino',
//       link: 'fl',
//       isActive: false
//   },
//   {
//       lang: 'Finnish',
//       link: 'fi',
//       isActive: false
//   },
//   {
//       lang: 'French',
//       link: 'fr',
//       isActive: false
//   },
//   {
//       lang: 'German',
//       link: 'de',
//       isActive: false
//   },
//   {
//       lang: 'Greek',
//       link: 'el',
//       isActive: false
//   },
//   {
//       lang: 'Gujarati',
//       link: 'gu',
//       isActive: false
//   },
//   {
//       lang: 'Hebrew',
//       link: 'iw',
//       isActive: false
//   },
//   {
//       lang: 'Hindi',
//       link: 'hi',
//       isActive: false
//   },
//   {
//       lang: 'Hungarian',
//       link: 'hu',
//       isActive: false
//   },
//   {
//       lang: 'Icelandic',
//       link: 'is',
//       isActive: false
//   },
//   {
//       lang: 'Indonesian',
//       link: 'id',
//       isActive: false
//   },
//   {
//       lang: 'Italian',
//       link: 'it',
//       isActive: false
//   },
//   {
//       lang: 'Japanese',
//       link: 'jp',
//       isActive: false
//   },
//   {
//       lang: 'Kannada',
//       link: 'kn',
//       isActive: false
//   },
//   {
//       lang: 'Korean',
//       link: 'ko',
//       isActive: false
//   },
//   {
//       lang: 'Latvian',
//       link: 'lv',
//       isActive: false
//   },
//   {
//       lang: 'Lithuanian',
//       link: 'lt',
//       isActive: false
//   },
//   {
//       lang: 'Malay',
//       link: 'ms',
//       isActive: false
//   },
//   {
//       lang: 'Malayalam',
//       link: 'ml',
//       isActive: false
//   },
//   {
//       lang: 'Marathi',
//       link: 'mr',
//       isActive: false
//   },
//   {
//       lang: 'Norwegian',
//       link: 'no',
//       isActive: false
//   },
//   {
//       lang: 'Polish',
//       link: 'pl',
//       isActive: false
//   },
//   {
//       lang: 'Romanian',
//       link: 'ro',
//       isActive: false
//   },
//   {
//       lang: 'Russian',
//       link: 'ru',
//       isActive: false
//   },
//   {
//       lang: 'Serbian',
//       link: 'sr',
//       isActive: false
//   },
//   {
//       lang: 'Chinese',
//       link: 'zh',
//       isActive: false
//   },
//   {
//       lang: 'Slovak',
//       link: 'sk',
//       isActive: false
//   },
//   {
//       lang: 'Slovenian',
//       link: 'sl',
//       isActive: false
//   },
//   {
//       lang: 'Spanish',
//       link: 'es',
//       isActive: false
//   },
//   {
//       lang: 'Swahili',
//       link: 'sw',
//       isActive: false
//   },
//   {
//       lang: 'Swedish',
//       link: 'sv',
//       isActive: false
//   },
//   {
//       lang: 'Tamil',
//       link: 'ta',
//       isActive: false
//   },
//   {
//       lang: 'Telugu',
//       link: 'te',
//       isActive: false
//   },
//   {
//       lang: 'Thai',
//       link: 'th',
//       isActive: false
//   },
//   {
//       lang: 'TRChinese',
//       link: 'zh',
//       isActive: false
//   },
//   {
//       lang: 'Turkish',
//       link: 'tr',
//       isActive: false
//   },
//   {
//       lang: 'Urdu',
//       link: 'ur',
//       isActive: false
//   },
//   {
//       lang: 'Ukrainian',
//       link: 'ua',
//       isActive: false
//   },
//   {
//       lang: 'Vietnamese',
//       link: 'vi',
//       isActive: false
//   },
//   {
//       lang: 'Welsh',
//       link: 'cy',
//       isActive: false
//   },
// ];

document.addEventListener('DOMContentLoaded', function() {
  langs = JSON.parse(langs);
  const langsDuplicate = [...langs];
  const wrapperLangsEls = document.querySelectorAll('.wrapper_langs .items_langs');

  function renderLangs(element) {
    element.innerHTML = '';
    langs.forEach(lang => {
      let tmpHtml = `<a href="${lang.link}" class="item_lang">${lang.lang}</a>`;
      if(lang.isActive) {
        tmpHtml = `<a href="${lang.link}" class="item_lang active">${lang.lang}</a>`;
      }
      element.insertAdjacentHTML('beforeend', tmpHtml);
    });
  }

  function startRenderBlocksLang() {
    wrapperLangsEls.forEach(element => {
      renderLangs(element);
    });
  }

  startRenderBlocksLang();


  const searchLangEls = document.querySelectorAll(".search-lang");

  function setListenerSearchLang(element) {
    element.addEventListener("input", function(){
      let toSearch = element.value.toLowerCase(); 
    
      langs = langsDuplicate.filter(o => o.lang.toLowerCase().includes(toSearch));
    
      startRenderBlocksLang();
    });
  }

  searchLangEls.forEach(element => {
    setListenerSearchLang(element)
  });

}, false);
// END LANGS